<template>
    <div class="landing-view" >
        <div class="cloud-container">
            <img class="cloud" v-for="index in 12" :key="index" ref="clouds" src="/static/img/Wolkje.png" />
        </div>
        <div class="world" ref="world">
            <div class="building-wrapper" v-touch:swipe.native="onSwipe">
                <floor-section v-for="floor in floors" :key="floor.id" :floor="floor" :activeFloor="activeFloor" :max="floors.length" @requestOverlay="showOverlay"></floor-section>
            </div>
        </div>

        <div class="button-wrapper">
            <button :class="{ hideBtn: activeFloor === 7 }" @click="floorNavProxy( 'up' )"><span>&uparrow;</span></button>
            <button :class="{ hideBtn: activeFloor === 0 }" @click="floorNavProxy( 'down' )"><span>&downarrow;</span></button>
        </div>

        <welkomPanel @hide="startBuildingAnim"></welkomPanel>

        <transition mode="out-in" @enter="animateInOverlay" @leave="animateOutOverlay" :css="false">
            <div class="overlay" v-if="overlay" @click.self="overlay = null">
                <div class="panel">
                    <a href="#" @click="overlay = null" class="close">&times;</a>
                    <infoBall :ballSize="80" :strokeWidth="4" :fontSize="2" :bubbleId="overlayIndex"/>
                    <div class="height-constrainer">
                        <component :is="overlay.component"></component>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<style lang="scss">
    .button-wrapper{
        position:absolute;
        top:50%;
        right:1rem;
        transform:translateY(-50%);

        display:flex;
        flex-direction:column;

        button{
            display:block;
            margin-bottom:1rem;

            background-color:rgba(255,255,255,0.2);
            transition: background-color 0.15s ease-out;

            &:hover{
                background-color:rgba(255,255,255,0.3);
            }

            span{
                display:inline-block;
                // transform:scaleX(2);
                font-weight:900;
            }

            &.hideBtn{
                opacity:0;
                pointer-events:none;
            }
        }
    }
</style>

<script>
    // import Form from '@/app/components/Form';
    import floorSection from '@/app/components/FloorSections';
    import { TimelineMax, TweenMax } from '@/vendor';
    // import { Lethargy } from 'lethargy';
    import ball from '@/app/components/Ball';
    import welkomPanel from '@/app/components/WelkomPanel';

    import overlays from '@/app/pages/overlays';

    // let lethargy = new Lethargy(); // new Lethargy( 7, 50, 0.05 );

    export default {
        name: 'Landing',

        components: {
            // 'v-form': Form
            'floor-section': floorSection,
            'infoBall': ball,
            'welkomPanel': welkomPanel
        },

        data()
        {
            return {
                duringAnim: false,
                preventInteraction: true,
                activeFloor: 7,
                overlay: null,
                floors: [
                    {
                        id: 0,
                        url: '/static/img/FieldLab_0.png',
                        videoUrl: '/static/videos/display_centrePiece.mp4',
                        videoUrlElevator: '/static/videos/elevator_foyer.mp4',
                        info: [
                            {
                                title: 'FIELD-LAB'
                            },
                            {
                                title: 'Kansen voor West en Europa'
                            },
                            {
                                title: 'Lift-uitleg'
                            }
                        ]
                    },
                    {
                        id: 1,
                        url: '/static/img/FieldLab_1.png',
                        info: [
                            {
                                title: 'Advancing Nuclear Medicine'
                            },
                            {
                                title: 'Artist Impression'
                            },
                            {
                                title: 'Marktleider'
                            },
                            {
                                title: 'Mensen'
                            },
                            {
                                title: '30.000 per dag'
                            }
                        ]
                    },
                    {
                        id: 2,
                        url: '/static/img/FieldLab_2.png',
                        info: [
                            {
                                title: 'PALLAS-reactor'
                            },
                            {
                                title: 'PALLAS'
                            },
                            {
                                title: 'Nuclear Health Centre (NHC)'
                            },
                            {
                                title: 'Medische isotopen'
                            }
                        ]
                    },
                    {
                        id: 3,
                        url: '/static/img/FieldLab_3.png',
                        info: [
                            {
                                title: 'FutureChemistry'
                            },
                            {
                                title: 'Waarin wij ons onderscheiden'
                            },
                            {
                                title: 'Onze trots'
                            },
                            {
                                title: 'Wat ons uniek maakt'
                            }
                        ]
                    },
                    {
                        id: 4,
                        url: '/static/img/FieldLab_4.png',
                        info: [
                            {
                                title: 'Erasmus MC'
                            },
                            {
                                title: 'Waarin wij ons onderscheiden'
                            },
                            {
                                title: 'Onze trots'
                            },
                            {
                                title: 'Wat ons uniek maakt'
                            }
                        ]
                    },
                    {
                        id: 5,
                        url: '/static/img/FieldLab_5.png',
                        info: [
                            {
                                title: 'Antoni van Leeuwenhoek'
                            },
                            {
                                title: 'Wie zijn wij?'
                            },
                            {
                                title: 'Ons verhaal'
                            }
                        ]
                    },
                    {
                        id: 6,
                        url: '/static/img/FieldLab_6.png',
                        info: [
                            {
                                title: 'Radmoudumc Missie'
                            },
                            {
                                title: 'Prostaat specifieke tracers'
                            },
                            {
                                title: 'Beeldvorming van prostaatkanker'
                            },
                            {
                                title: 'Behandeling van prostaatkanker'
                            }
                        ]
                    },
                    {
                        id: 7,
                        url: '/static/img/FieldLab_7.png',
                        info: [
                            {
                                title: 'UMC Amsterdam'
                            },
                            {
                                title: 'Trade Center Amsterdam'
                            },
                            {
                                title: 'Research'
                            },
                            {
                                title: 'Core facilities'
                            }
                        ]
                    }
                ]
            };
        },

        created()
        {
            for( let i = 0; i < this.floors.length; i++ )
            {
                for( let j = 0; j < this.floors[i].info.length; j++ )
                {
                    this.floors[i].info[j]['component'] = overlays[ 'floor' + i + '_' + ( j + 1 ) ];
                }
            }
        },

        mounted()
        {
            let floorOffset = 158.57 / 1920 * window.innerWidth;
            TweenMax.to( this.$refs.world, 0.3, { y: floorOffset * 15 });

            for( let cloud of this.$refs.clouds )
            {
                this.randomizeValue( cloud );
            }

            this.animateClouds();

            this.liftNum = 0;

            window.addEventListener( 'wheel', this.onScroll );
        },

        methods: {
            showOverlay( data )
            {
                this.overlay = data.info;
                this.overlayIndex = data.index + 1;
                window.dataLayer.push({ 'event': 'pageview', 'page': 'floor-' + this.activeFloor, 'overlay': data.index + 1 });
            },

            onScroll( e )
            {
                if( this.preventInteraction === true )
                {
                    return;
                }

                if( !this.overlay )
                {
                    this.liftNum += e.deltaY;

                    if( Math.abs( this.liftNum ) > 400 )
                    {
                        if( this.liftNum > 0 )
                        {
                            this.goFloorDown();
                        }
                        else
                        {
                            this.goFloorUp();
                        }

                        this.liftNum = 0;
                    }
                }
            },

            onSwipe( e )
            {
                if( this.preventInteraction === true )
                {
                    return;
                }

                if( e === 'top' )
                {
                    this.goFloorDown();
                }
                else if( e === 'bottom' )
                {
                    this.goFloorUp();
                }
            },

            floorNavProxy( pWay )
            {
                if( this.preventInteraction === true )
                {
                    return;
                }

                if( pWay === 'up' )
                {
                    this.goFloorUp();
                }
                else
                {
                    this.goFloorDown();
                }
            },

            goFloorUp()
            {
                if( this.activeFloor < 7 )
                {
                    this.activeFloor = Math.min( 7, this.activeFloor + 1 );
                    let floorOffset = 158.57 / 1920 * window.innerWidth;
                    TweenMax.to( this.$refs.world, 0.3, { y: floorOffset * this.activeFloor });

                    if( !this.duringAnim )
                    {
                        window.dataLayer.push({ 'event': 'pageview', 'page': 'floor-' + this.activeFloor });
                    }
                }
            },

            goFloorDown()
            {
                if( this.activeFloor > 0 )
                {
                    this.activeFloor = Math.max( 0, this.activeFloor - 1 );
                    let floorOffset = 158.57 / 1920 * window.innerWidth;
                    TweenMax.to( this.$refs.world, 0.3, { y: floorOffset * this.activeFloor });

                    if( !this.duringAnim )
                    {
                        window.dataLayer.push({ 'event': 'pageview', 'page': 'floor-' + this.activeFloor });
                    }
                }
            },

            animateClouds()
            {
                let randomStart = Math.floor( Math.random() * ( 1 - 10 ) + 10 );
                let randomSpeed = Math.floor( Math.random() * ( 50 - 30 ) + 30 );
                let tl = new TimelineMax({ paused: true, repeat: -1 });

                tl.staggerFrom( '.cloud', randomSpeed, { x: window.innerWidth * 2, ease: Linear.easeNone }, randomStart, 0 );

                tl.play();
            },

            randomizeValue( pElem )
            {
                TweenMax.set( pElem, {
                    width: Math.floor( Math.random() * ( 50 - 10 ) + 10 ) + '%',
                    top: Math.floor( Math.random() * ( ( window.innerHeight / 2 ) - 1 ) + 1 ) + '%'
                });
            },

            animateInOverlay( el, done )
            {
                let tl = new TimelineMax({ onComplete: done });

                tl.from( '.overlay', 0.35, { autoAlpha: 0, ease: Linear.easeNone }, 0 );
                tl.from( '.panel', 0.35, { scale: 0.5, autoAlpha: 0, ease: Back.easeOut.config( 1.3 ) }, 0.15 );

                tl.play();
            },

            animateOutOverlay( el, done )
            {
                let tl = new TimelineMax({ onComplete: done });

                tl.to( '.overlay', 0.35, { autoAlpha: 0, ease: Linear.easeNone }, 0 );
                tl.to( ['.panel', '.welkom-panel'], 0.15, { scale: 0.5, autoAlpha: 0, ease: Linear.easeNone }, 0 );

                tl.play();
            },

            startBuildingAnim()
            {
                let tl = new TimelineMax({
                    paused: false,
                    delay: 1,
                    onStart: () =>
                    {
                        this.duringAnim = true;
                    },
                    onComplete: () =>
                    {
                        this.preventInteraction = false;
                        this.duringAnim = false;

                        window.dataLayer.push({ 'event': 'pageview', 'page': 'floor-0' });
                    }
                });

                let floorOffset = 158.57 / 1920 * window.innerWidth;
                tl.fromTo( '.world', 1, { y: '+=1000' }, { y: floorOffset * 7 }, 0 );

                tl.add( this.goFloorDown, 2 );
                tl.add( this.goFloorDown, 3.5 );
                tl.add( this.goFloorDown, 4.5 );
                tl.add( this.goFloorDown, 5.5 );
                tl.add( this.goFloorDown, 6.5 );
                tl.add( this.goFloorDown, 7.5 );
                tl.add( this.goFloorDown, 9 );

                tl.timeScale( 2 );
            }
        }
    };
</script>
